import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import styled from 'styled-components';
import { ASSETS_ROUTE } from 'Api/Routes';

const AvatarWrapper = styled(Avatar)`
  align-items: ${({ imageid }) =>
    imageid === 'true' ? 'unset' : 'center'} !important;
  cursor: pointer;
`;

function AvatarUser({ user, imageId, onClick }) {
  if (user && Object.keys(user).length > 0) {
    if (imageId) {
      return (
        <AvatarWrapper
          onClick={onClick ? onClick : null}
          className="mui-avatar"
          src={`${ASSETS_ROUTE}${imageId}`}
          imageid={'true'}
        />
      );
    } else {
      return (
        <AvatarWrapper
          onClick={onClick ? onClick : null}
          className="mui-avatar"
          imageid={'false'}
        >
          {`${user.firstName
            .toUpperCase()
            .charAt(0)}${user.lastName.toUpperCase().charAt(0)}`}
        </AvatarWrapper>
      );
    }
  } else {
    return false;
  }
}

export default AvatarUser;
